import type { ReactNode } from "react";

/** Envelope with two broadcast arcs — one mail, many recipients. Also the favicon. */
export function EdictaLogo({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden
    >
      <rect x="1.5" y="7" width="12" height="9.5" rx="1.5" />
      <path d="M2.2 8l5.3 4.2L12.8 8" />
      <path d="M13.5 4.2a2.8 2.8 0 0 1 2.8 2.8" />
      <path d="M13.5 1.2a5.8 5.8 0 0 1 5.8 5.8" />
    </svg>
  );
}

function icon(children: ReactNode) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="h-4 w-4"
      aria-hidden
    >
      {children}
    </svg>
  );
}

export const NAV_ICONS = {
  mails: icon(
    <>
      <rect x="1.5" y="3" width="13" height="10" rx="1.5" />
      <path d="M2 4l6 4.5L14 4" />
    </>,
  ),
  archive: icon(
    <>
      <rect x="1.5" y="2.5" width="13" height="3.5" rx="1" />
      <path d="M2.5 6v6.5a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V6M6.5 9h3" />
    </>,
  ),
  queue: icon(<path d="M2.5 4h11M2.5 8h11M2.5 12h7" />),
  bounces: icon(
    <>
      <path d="M6 4L2.5 7.5 6 11" />
      <path d="M2.5 7.5h7a4 4 0 0 1 4 4V13" />
    </>,
  ),
  sources: icon(
    <>
      <ellipse cx="8" cy="3.5" rx="5.5" ry="2" />
      <path d="M2.5 3.5v9c0 1.1 2.5 2 5.5 2s5.5-.9 5.5-2v-9M2.5 8c0 1.1 2.5 2 5.5 2s5.5-.9 5.5-2" />
    </>,
  ),
  templates: icon(
    <>
      <path d="M4 1.5h5.5L13 5v8.5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1Z" />
      <path d="M9.5 1.5V5H13M5.5 8.5h5M5.5 11h3.5" />
    </>,
  ),
  senders: icon(<path d="M14.5 1.5L7 9M14.5 1.5L10 14.5 7 9 1.5 6Z" />),
  apiKeys: icon(
    <>
      <circle cx="5" cy="11" r="3" />
      <path d="M7.2 8.8L14 2M11.5 4.5l2 2M10 6l1.5 1.5" />
    </>,
  ),
  users: icon(
    <>
      <circle cx="6" cy="5" r="2.5" />
      <path d="M1.5 13.5c0-2.5 2-4 4.5-4s4.5 1.5 4.5 4" />
      <path d="M10.5 2.8a2.3 2.3 0 0 1 0 4.4M12 9.8c1.5.5 2.5 1.8 2.5 3.7" />
    </>,
  ),
  audit: icon(
    <>
      <circle cx="8" cy="8" r="6.5" />
      <path d="M8 4.5V8l2.5 1.5" />
    </>,
  ),
} satisfies Record<string, ReactNode>;

export type NavIcon = keyof typeof NAV_ICONS;
